import React from 'react';
import type { GroupBase, GroupHeadingProps } from 'react-select';
import { components } from 'react-select';
import type { OptionTypeBase } from '../../components/Select';
import type {
  CategorizedSelectCustomProps,
  EntityCategoryOption,
  EntitySelectCategorizedSearchResult,
} from './CategorizedEntitySelect';
import CategoryHeadingButton from './CategoryHeadingButton';
import styles from './EntitySelectCategoryHeading.module.scss';

type EntitySelectCategoryHeadingProps<
  OptionType extends OptionTypeBase = { label: string; value: string },
  IsMulti extends boolean = boolean,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>,
> = GroupHeadingProps<OptionType, IsMulti, GroupType> & {
  selectProps: GroupHeadingProps<
    OptionType,
    IsMulti,
    GroupType
  >['selectProps'] &
    Partial<CategorizedSelectCustomProps>;
};

const EntitySelectCategoryHeading = <IsMulti extends boolean = boolean>(
  props: EntitySelectCategoryHeadingProps<
    EntitySelectCategorizedSearchResult,
    IsMulti,
    EntityCategoryOption
  >,
) => {
  const {
    selectProps: { selectedEntityCategory, onHeaderClick },
    data,
  } = props;

  return (
    <div className={styles.container}>
      <components.GroupHeading {...props} />
      {(data.sliced || selectedEntityCategory === data.type) && (
        <CategoryHeadingButton
          selectedEntityCategory={selectedEntityCategory}
          onHeaderClick={() => onHeaderClick?.(data.type)}
        />
      )}
    </div>
  );
};

export default EntitySelectCategoryHeading;
